"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const html_parser_1 = require("../../compiler/src/ml_parser/html_parser");
let parser = null;
const getParser = () => {
    if (!parser) {
        parser = new html_parser_1.HtmlParser();
    }
    return parser;
};
function parse(input, { canSelfClose = false, allowHtmComponentClosingTags = false, isTagNameCaseSensitive = false } = {}) {
    return getParser().parse(input, "angular-html-parser", {
        tokenizeExpansionForms: false,
        interpolationConfig: undefined,
        canSelfClose,
        allowHtmComponentClosingTags
    }, isTagNameCaseSensitive);
}
exports.parse = parse;
